import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import SearchIcon from 'react-icons/lib/fa/search';

import A from 'wanderu-component-react-router-link';
import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { buildSearchUrlPath } from 'wanderu-utils';

import Events from '../events/PriceGridEvents';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './GridItem.scss';

const propTypes = {
    date: PropTypes.string.isRequired,
    i18nMoney: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    locationData: PropTypes.shape({
        arrival: PropTypes.shape({
            formattedAddress: PropTypes.string,
            placeId: PropTypes.string,
        }),
        departure: PropTypes.shape({
            formattedAddress: PropTypes.string,
            placeId: PropTypes.string,
        }),
    }),
    onClick: PropTypes.func,
    price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    selected: PropTypes.bool,
    showDateOnly: PropTypes.bool,
};

function DateField(props) {
    const {
        date,
        i18nMoment,
        split,
    } = props;

    const dateString = i18nMoment(date);
    const day = dateString.format('ddd');
    const monthAndDate = dateString.format('MMM D');

    return (
        <div
            className={classNames(
                styles.dayLabel,
                { [styles.split]: split },
            )}
        >
            <span className={styles.label}>
                {day}
            </span>
            <span>{monthAndDate}</span>
        </div>
    );
}

DateField.propTypes = {
    date: PropTypes.string.isRequired,
    i18nMoment: PropTypes.func.isRequired,
    split: PropTypes.bool,
};

const LocalizedDateField = localize(DateField);

function PriceLink(props) {
    const {
        date,
        index,
        locationData,
        price,
    } = props;

    const {
        departure,
        arrival,
    } = locationData;

    const href = buildSearchUrlPath({
        arrivePlace: arrival.formattedAddress,
        arrivePlaceId: arrival.placeId,
        departDate: date,
        departPlace: departure.formattedAddress,
        departPlaceId: departure.placeId,
    });

    function trackEvent() {
        Events.dateClicked({ date, index, price });
    }

    return (
        <A
            className={styles.link}
            href={href}
            onClick={trackEvent}
        >
            <LocalizedDateField date={date} />
            <div className={styles.price}>
                {price || (
                    <SearchIcon className={styles.searchIcon} />
                )}
            </div>
        </A>
    );
}

PriceLink.propTypes = {
    date: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    locationData: PropTypes.shape({
        arrival: PropTypes.shape({
            formattedAddress: PropTypes.string,
            placeId: PropTypes.string,
        }),
        departure: PropTypes.shape({
            formattedAddress: PropTypes.string,
            placeId: PropTypes.string,
        }),
    }),
    price: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

function GridItem(props) {
    const {
        date,
        i18nMoney,
        index,
        locationData = {},
        onClick = () => undefined,
        price = '',
        selected = false,
        showDateOnly = false,
    } = props;

    const priceString = showDateOnly
        ? ''
        : i18nMoney(price).format({
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        });

    function handleClick() {
        Events.dateClicked({ date, index });
        onClick(date);
    }

    return (
        <li
            className={classNames(
                styles.day,
                {
                    [styles.withBorders]: !showDateOnly,
                    [styles.selected]: selected,
                },
            )}
            key={date}
        >
            {showDateOnly
                ? (
                    <Button
                        className={classNames(
                            styles.dateButton,
                            { [styles.selected]: selected },
                        )}
                        onClick={handleClick}
                        unstyled
                    >
                        <LocalizedDateField
                            date={date}
                            split
                        />
                    </Button>
                )
                : (
                    <PriceLink
                        date={date}
                        index={index}
                        locationData={locationData}
                        price={priceString}
                    />
                )}
        </li>
    );
}

GridItem.propTypes = propTypes;

export {
    DateField,
    GridItem,
    PriceLink,
};
export default localize(GridItem);
